import { render, staticRenderFns } from "./CertificateInformation.vue?vue&type=template&id=0bb4e23d&scoped=true"
import script from "./CertificateInformation.vue?vue&type=script&lang=js"
export * from "./CertificateInformation.vue?vue&type=script&lang=js"
import style0 from "./CertificateInformation.vue?vue&type=style&index=0&id=0bb4e23d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb4e23d",
  null
  
)

export default component.exports